<div style="width: 90%; padding: 0; margin: 0; position: relative; min-height: 300px;">
  <highcharts-chart *ngIf="showAveragesChart" [Highcharts]="Highcharts" [options]="averagesChartOptions"
    style="width: 100%; height: 100%; display: block; margin-bottom: 18px;"></highcharts-chart>
  <div *ngIf="noDataFound"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">No Record found for selected date range</h6>
  </div>
</div>

<div style="width: 90%; padding: 0; margin: 0; position: relative; min-height: 300px;">
  <highcharts-chart 
    *ngIf="showGmiChart"
    [Highcharts]="Highcharts"
    [options]="gmiChartOptions"
    style="width: 100%; height: 100%; display: block; margin-bottom: 18px;"
  ></highcharts-chart>
  <div *ngIf="gmiNoDataFound"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">No Record found for selected date range</h6>
  </div>
</div>

<div class="col-md-12 flex mt-5">
  <div class="col">
    <div class="gridSub">
      <div class="col-md-12">
        <img style="width: 25%;" src="/assets/img/memberdashboard/glus2.png" />
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridTitle">Average Fasting Glucose</div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridVal">{{details.avgFastingGlucose>0?details.avgFastingGlucose+' mg/dl':'---'}}</div> &nbsp; <div
          style="width: 100%; height: 100%; background: #20AA4A; border-radius: 9999px"></div>
      </div>
    </div>
  </div>

  <div class="col">
    <div class="gridSub">
      <div class="col-md-12">
        <img style="width: 25%;" src="/assets/img/memberdashboard/glus1.png" />
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridTitle">Average Post Meal Glucose</div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridVal">{{details.avgPostMealGlucose>0?details.avgPostMealGlucose+' mg/dl':'---'}}</div> &nbsp;
        <div style="width: 100%; height: 100%; background: #20AA4A; border-radius: 9999px"></div>
      </div>
    </div>
  </div>
  <!-- Average Glucose Level -->
  <div class="col">
    <div class="gridSub">
      <div class="col-md-12">
        <img style="width: 25%;" src="/assets/img/memberdashboard/glus3.png" />
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridTitle">Average Glucose</div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridVal">{{details.avgGlucose>0?details.avgGlucose+' mg/dl':'---'}}</div> &nbsp; <div
          style="width: 100%; height: 100%; background: #20AA4A; border-radius: 9999px"></div>
      </div>
    </div>
  </div>

  <!-- GMI -->
  <div class="col">
    <div class="gridSub">
      <div class="col-md-12">
        <img style="width: 25%;" src="/assets/img/memberdashboard/gmi.png" />
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridTitle">Glucose Management Indicator</div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridVal">
          {{ details.gmi > 0 ? details.gmi + ' %' : '---' }}
        </div>
      </div>
    </div>
  </div>

  <!-- MAGE -->
  <div class="col">
    <div class="gridSub">
      <div class="col-md-12">
        <img style="width: 25%;" src="/assets/img/memberdashboard/mage.png" />
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridTitle">Mean Amplitude of Glycemic Excursions</div>
      </div>
      <div class="col-md-12 mt-3">
        <div class="gridVal">
          {{ details.mage > 0 ? details.mage + ' mg/dl' : '---' }}
        </div>
      </div>
    </div>
  </div>

</div>